<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card :title="'Staff Skills'" class="" cardBorder>
                <template slot="actions">
                    <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4 hidden"
                        color="primary" type="filled">Add New</vs-button>
                </template>
                <vx-card cardBorder noShadow titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters">
                    <div class="vx-row">
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Staff Users</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="true"
                                v-model="filters['staff-ids']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.value" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Skills</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="true"
                                v-model="filters['skill-ids']" :options="skill_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.id" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Skill Categories</label>
                            <v-select :clearable="false" placeholder="" v-model="filters['categories']"
                                :options="categories" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" multiple
                                :reduce="option => option.id">
                            </v-select>
                        </div>
                    </div>
                    <div class="mt-5 vx-row">
                        <div class="w-full ml-auto vx-col">
                            <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                                icon-pack="feather" v-on:click="filters = {}">CLEAR</vs-button>
                        </div>
                    </div>
                </vx-card>
                <div id="manage-staff-skills-table" class="vx-row">
                    <div class="w-full vx-col">

                        <vs-table stripe sort class="mt-8" :data="staff_skills">
                            <template slot="thead">
                                <vs-th width="15%">Name</vs-th>
                                <vs-th width="15%">Staff User</vs-th>
                                <vs-th width="10%">Category</vs-th>
                                <vs-th width="10%">Proficiency Level</vs-th>
                                <vs-th width="10%">Years of Experience</vs-th>
                                <vs-th width="30%">Notes</vs-th>
                                <vs-th width="10%"></vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].skill.name">
                                        {{ data[indextr].skill.name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].staff.name">
                                        {{ data[indextr].staff.name }} <br>
                                        {{ data[indextr].staff.email }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].skill.category.name">
                                        {{ data[indextr].skill.category.name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].proficiency_level">
                                        {{ data[indextr].proficiency_level || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].years_of_experience">
                                        {{ data[indextr].years_of_experience || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].notes">
                                        {{ data[indextr].notes }}
                                    </vs-td>

                                    <vs-td>
                                        <div class="justify-start vx-row">
                                            <vx-tooltip text="View/Update" position="left">
                                                <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3"
                                                    size="small" color="warning" type="border" icon-pack="feather"
                                                    icon="icon-edit-2"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip text="Delete Skill" position="left">
                                                <vs-button @click.stop="onClickDeleteConfirmation(data[indextr].id)"
                                                    class="ml-3" size="small" color="danger" type="border"
                                                    icon-pack="feather" icon="icon-trash"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </vx-card>
        </div>
        <AddNewMySkillPopUp ref="addNewMySkillPopUp" />
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewMySkillPopUp from '@/components/popups/my-skill-qualifications/AddNewMySkillPopUp.vue'

import vSelect from 'vue-select'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { mapActions, mapGetters } from 'vuex';

import { defaultPagination, perPageList } from "@/constants/config";

const SkillQualificationRepository = RepositoryFactory.get('skills');

export default {
    name: "ManageStaffSkills",
    data() {
        return {
            staff_skills: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            skill_list: [],
            categories: []
        }
    },
    props: {
        staff_id: {
            type: String,
            required: true
        },
        action_buttons: {
            type: Boolean,
            default: true
        }
    },
    components: {
        AddNewMySkillPopUp,
        'v-select': vSelect,
    },
    methods: {
        ...mapActions(['fetchStaffs']),
        async refreshData() {
            await this.fetchStaffSkills()
        },
        async fetchStaffSkills() {
            await this.$vs.loading({
                container: '#manage-staff-skills-table',
                scale: 0.45
            })
            const { data } = await SkillQualificationRepository.getListOfAllStaffSkills(this.page, this.filterQuery, this.perPage, this.sort)
            this.staff_skills = data.data
            this.meta = data.meta
            this.$vs.loading.close('#manage-staff-skills-table > .con-vs-loading')
        },
        async onClickAdd() {
            await this.$refs.addNewMySkillPopUp.openPopup()
        },
        async onClickUpdate(id) {
            await this.$refs.addNewMySkillPopUp.openPopup(id)
        },
        filterQueryUpdate() {
            this.fetchStaffSkills()
        },
        handleChangePage(page) {
            this.page = page;
            this.fetchStaffSkills()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchStaffSkills()
            }
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        onClickDeleteConfirmation(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure you want to delete this ?',
                accept: this.onClickDelete,
                parameters: [id]
            })
        },
        async onClickDelete(params) {
            await this.$vs.loading({
                container: '#manage-staff-skills-table',
                scale: 0.45
            })
            try {
                await SkillQualificationRepository.deleteMySkills(params[0])
                await this.refreshData()
            } catch (error) {

            } finally {
                this.$vs.loading.close('#manage-staff-skills-table > .con-vs-loading')
            }
        },
        async fetchSkillList() {
            await this.$vs.loading({
                container: '#manage-staff-skills-table',
                scale: 0.45
            })
            try {
                const { data } = (await SkillQualificationRepository.getListOfStaffSkillsDropdown()).data
                this.skill_list = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#manage-staff-skills-table > .con-vs-loading')
        },
        async fetchCategoryList() {
            await this.$vs.loading({
                container: '#manage-staff-skills-table',
                scale: 0.45
            })
            try {
                const { data } = (await SkillQualificationRepository.getSkillQualificationCategoriesDropdown('Skill')).data
                this.categories = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#manage-staff-skills-table > .con-vs-loading')
        },
    },
    async mounted() {
        await this.fetchStaffs()
        await this.fetchSkillList()
        await this.fetchCategoryList()
    },
    computed: {
        ...mapGetters(['staffs']),
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    watch: {
        page() {
            this.fetchStaffSkills()
        },
        perPage() {
            this.fetchStaffSkills()
        }
    }
}
</script>

<style scoped></style>